import React from "react"
import {Button, Card, CardBody, Col, Input} from "reactstrap";

import {CopyToClipboard} from "react-copy-to-clipboard"
import {toast} from "react-toastify";

export default class FileContainer extends React.Component {
  constructor(props) {
    super(props);

    const data = this.props.data? Object.entries(this.props.data).map(([key, val])=> `${key}\t${val}`):["None"]

    this.state = {
      intitialitems: data,
      filtered: data,
    };
  }

  updateFilter(value) {
    let filtered = this.state.intitialitems.filter(item=>item.toLowerCase().search(value.toLowerCase()) !== -1)

    this.setState({filtered: filtered})
  }

  render() {
    return (
      <Card color="primary" outline>
        <CardBody>
          <span>{this.props.type} files</span>
          <CopyToClipboard text={this.state.filtered.join('\n') || 'None'} onCopy={()=>{toast.info('Copied to clipboard')}}>
            <Button className="float-right" size={'sm'}>Copy to clipboard</Button>
          </CopyToClipboard>
          <Input className="my-3" size='sm' type="text" placeholder="Filter" onChange={(e)=>this.updateFilter(e.target.value)}/>
          <pre>
          {this.state.filtered.join('\n') || 'None'}
        </pre>
        </CardBody>
      </Card>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Verification/FileContainer.js